import React from "react"
import { navigate } from "gatsby"
//import { LanguageContext } from "../context"
//import { translate } from "../translate"
import Icon from "./icon"
import Dropdown from "react-bootstrap/Dropdown"
import DropdownButton from 'react-bootstrap/DropdownButton';
import PropTypes from "prop-types"
import Utils from "../utils"


const ButtonGeneric = (props) => {

  const {
      title,
      className,
      icon,
      iconSize,
      iconColor,
      iconClassName,
      disabled,
      onClick,
      type,
      options,
      action
  } = props

  const handleSelect= async (e) => {
   const url = typeof window !== 'undefined' ? window.location.href : ''

   const newurl = Utils.addOrReplaceParam(url, 'cat', e)
   let paramString = newurl.split('?')[1];
   try {
     await navigate(`${action}/?${paramString}`);
   } catch (err) {
     console.error(err);
   }
  }


  if(type === 'dropdown'){
    return (

      <DropdownButton
        title={title}
        id="dropdown-menu-align-right"
        className={className}
        onSelect={handleSelect}
        >
        {options && options?.edges?.length > 0 && options?.edges?.map(({node}, index) => {
            return (<Dropdown.Item key={index} eventKey={node?.title ? node.title : node?.name ? node?.name : ''}>{node?.title ? node.title : node?.name ? node?.name : ''}</Dropdown.Item>)
        }
        )}
        </DropdownButton>
   );
  }else{
    return (
      <button
        className={className}
        disabled={disabled}
        onClick={onClick}
      >
        {title}
        {icon &&
          <Icon
            icon={icon}
            className={iconClassName}
            size={iconSize}
            color={iconColor}
          />
        }
     </button>
    )
  }




}

ButtonGeneric.propTypes = {
  className: PropTypes.string,
  type: PropTypes.string,
  options: PropTypes.object
}

ButtonGeneric.defaultProps = {
  className: ``,
  type: `normal`,
  optins: ``
}

export default ButtonGeneric
